import { Box } from '@mui/material';
import { Button, Typography, colors } from '@sweep-io/sweep-design';
import { Database } from '@sweep-io/sweep-design/dist/icons';

interface CreditQueueBannerProps {
  upNextName?: string;
  onCreditQueueClick: () => void;
}

export const CreditQueueBanner = ({ upNextName, onCreditQueueClick }: CreditQueueBannerProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: colors.grey[200],
        borderRadius: '8px',
        padding: '12px 16px',
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <Database />
        <Typography variant="body-medium">Credit queue active -</Typography>
        <Typography variant="body" color={colors.grey[700]}>
          Records route to members with credits first.
        </Typography>
        {upNextName && (
          <>
            <Box
              sx={{
                width: '1px',
                height: '16px',
                backgroundColor: colors.grey[500],
              }}
            />
            <Typography variant="body-medium">Up Next</Typography>
            <Typography variant="body" color={colors.grey[700]}>
              {upNextName}
            </Typography>
          </>
        )}
      </Box>
      <Button variant="system" size="small" onClick={onCreditQueueClick}>
        Credit Queue
      </Button>
    </Box>
  );
};
